import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Currency} from '../../../../../shared/api/entity';


@Component({
    selector: 'tfl-bo-available-currency',
    template: `
        <tfl-bo-badge *ngFor="let currencyId of currencyIds">
            {{currencyId | value_by_key:currencies}}

            <i *ngIf="isCurrencyAvailable(currencyId)"
               class="fa fa-check-circle fa-lg green"
            ></i>

            <i *ngIf="!isCurrencyAvailable(currencyId)"
               class="fa fa-exclamation-triangle fa-lg red"
               title="{{currencyId|value_by_key:currencies}}{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UNAVAILABLE_CURRENCY'|translate}}"
            ></i>
        </tfl-bo-badge>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvailableCurrencyComponent {
    @Input() currencies: Currency[];
    @Input() currencyIds: string[] | number[];

    isCurrencyAvailable(id): boolean {
        return this.currencies.find(currency => currency.id === +id).available;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/available-currency/available-currency.component.ts